// context/ThemeContext.jsx
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const ThemeContext = createContext();

const themeModes = {
    light: { background: '#f5f5f5', headerFooter: '#dcdcdc', text: '#000', bodyText: '#fff', bodyBackground: '#121212' },
    dark: { background: '#121212', headerFooter: '#000', text: '#fff', bodyText: '#000', bodyBackground: '#f5f5f5' },
};

export const ThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => localStorage.getItem('themeMode') || 'dark');

    useEffect(() => {
        localStorage.setItem('themeMode', mode);
    }, [mode]);

    const toggleMode = () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

    const themeConfig = themeModes[mode];

    const muiTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    background: {
                        default: themeConfig.background,
                        paper: themeConfig.headerFooter,
                    },
                    text: {
                        primary: themeConfig.text,
                    },
                },
                typography: {
                    fontFamily: 'Roboto, sans-serif',
                },
                components: {
                    MuiCssBaseline: {
                        styleOverrides: {
                            body: {
                                backgroundColor: themeConfig.background,
                                color: themeConfig.text,
                                transition: 'all 0.3s ease',
                            },
                            '*': {
                                transition: 'background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease',
                            },
                        },
                    },
                },
            }),
        [mode]
    );

    return (
        <ThemeContext.Provider value={{ theme: themeConfig, mode, toggleMode }}>
            <MuiThemeProvider theme={muiTheme}>
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};

export const useThemeContext = () => useContext(ThemeContext);
